import React, { ReactElement, useEffect } from 'react';
import styles from './loginPage.module.scss';
import { LoginForm } from './loginForm/LoginForm';
import { usePingAuthFlow } from './usePingAuthFlow/usePingAuthFlow';
import { USERNAME_PASSWORD_REQUIRED_STATUS } from '../../domain/AuthFlowState';
import { useQueryParam } from '@mo/hooks';

function LoginPage(): ReactElement | null {
    const { flowId } = useQueryParam(window.location.href);
    const { loading, authFlowState, redirectUrl, error } = usePingAuthFlow(flowId);

    useEffect(() => {
        if (error && redirectUrl) {
            window.location.replace(redirectUrl);
        }
    }, [error, redirectUrl]);

    if (loading || authFlowState.status !== USERNAME_PASSWORD_REQUIRED_STATUS) {
        return null;
    }

    return (
        <div className={styles.loginBackground}>
            <div className={styles.gridContainer}>
                <div className={styles.page}>
                    <LoginForm flowId={authFlowState.id} loginUrl={authFlowState._links.checkUsernamePassword} />
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
